import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.modalId = 'videoModal';
    this.dom = {
      $el: this.el,
      $body: document.body
    };

    this.popupId = this.dom.$el.dataset.popupId;

    this.popup = document.querySelector(this.popupId);

    this.closeButton = this.popup.querySelector('[data-micromodal-close]');
    this.clickedButton = document.querySelector('.account-message__action');
  }

  addListeners() {
    this.dom.$el._on('click', this.open.bind(this));

    if (this.closeButton){
      this.closeButton._on('click', this.close.bind(this));
    }

    if (this.clickedButton){
      this.clickedButton._on('click', this.close.bind(this));
    }
  }

  close() {

    this.popup.style.display = 'none';
    this.dom.$body.classList.remove('popup-scroll');

    const inputs = this.popup.getElementsByTagName('input');
    for(let i = 0; i < inputs.length; i++) {
      if (inputs[i].type !== 'hidden' && inputs[i].type !== 'checkbox') {
        inputs[i].value = '';
      }
    }

    const badges = document.getElementsByClassName('grecaptcha-badge');
    for(let i = 0; i < badges.length; i++) {
      document.body.appendChild(badges[i]);
      badges[i].style.display = 'none';
    }
  }

  open() {
    const badges = document.getElementsByClassName('grecaptcha-badge');
    for(let i = 0; i < badges.length; i++) {
      document.body.appendChild(badges[i]);
      badges[i].style.display = 'block';
    }

    this.popup.style.display = 'block';
    this.dom.$body.classList.add('popup-scroll');
  }
}

export default Module;
